export const auth = {
  accounts: [
    {
      name: "Jack",
      username: "jj123K",
      password: "123456",
    },
    {
      name: "David",
      username: "david",
      password: "123456",
    },
  ],
};
